// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-products{
        
        width:100%;
        display: flex;
        justify-content: center;
        
        
        
}

.add-products-card {
    width: 80%;
    height:100vh;
    overflow: scroll;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: left;
        align-items: left;
        border-radius: 10px;
        padding: 10px;
        
       
}

.add-products-form{
    display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

}

.add-products-form input {
    height: 50px;
    margin-bottom: 20px;
    width: 90%;
    font-size: large;
    font-family: 'Poppins', sans-serif;
    font-weight: 100;
    padding-left: 20px;
}
.add-products-form textarea {
    height: 50px;
    margin-bottom: 20px;
    width: 90%;
    font-size: large;
    font-family: 'Poppins', sans-serif;
    font-weight: 100;
    padding-left: 20px;
}

.add-products-form button{
    width:120px;
    height:50px;
    background-color: #ed2727;
    color:#fff;
    border-radius: 5px;
    cursor:pointer;
}

.add-products-form button:hover{
    background-color:#ffa406 ;
}

.checkbox-container input{
    width:20px;
    height:20px;
   
}

.add-products-form label {
    height: 50px;
   
    width: 90%;
    font-size: large;
    font-family: 'Poppins', sans-serif;
    font-weight: 100;
   
    text-align: left;
}

.input-group{
    display: flex;
    padding:0px 50px;
    width:90%;
    
    
}

.input-group select{
    margin: 10px 0px;
}

@media screen and (max-width:768px){
    .add-products{
        width:100%;
    }
  .add-products-card {
      width: 100%;
      height: 100vh;
      overflow: scroll;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: left;
      align-items: left;
      border-radius: 10px;
      padding: 10px;
      margin:20px auto;


  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/addProducts.css"],"names":[],"mappings":"AAAA;;QAEQ,UAAU;QACV,aAAa;QACb,uBAAuB;;;;AAI/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;QACZ,sBAAsB;QACtB,aAAa;QACb,sBAAsB;QACtB,qBAAqB;QACrB,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;;;AAGrB;;AAEA;IACI,aAAa;QACT,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;;AAE3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;;AAEf;;AAEA;IACI,YAAY;;IAEZ,UAAU;IACV,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;;IAEhB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;;;AAGb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;IACd;EACF;MACI,WAAW;MACX,aAAa;MACb,gBAAgB;MAChB,sBAAsB;MACtB,aAAa;MACb,sBAAsB;MACtB,qBAAqB;MACrB,iBAAiB;MACjB,mBAAmB;MACnB,aAAa;MACb,gBAAgB;;;EAGpB;AACF","sourcesContent":[".add-products{\n        \n        width:100%;\n        display: flex;\n        justify-content: center;\n        \n        \n        \n}\n\n.add-products-card {\n    width: 80%;\n    height:100vh;\n    overflow: scroll;\n        background-color: #fff;\n        display: flex;\n        flex-direction: column;\n        justify-content: left;\n        align-items: left;\n        border-radius: 10px;\n        padding: 10px;\n        \n       \n}\n\n.add-products-form{\n    display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n\n}\n\n.add-products-form input {\n    height: 50px;\n    margin-bottom: 20px;\n    width: 90%;\n    font-size: large;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 100;\n    padding-left: 20px;\n}\n.add-products-form textarea {\n    height: 50px;\n    margin-bottom: 20px;\n    width: 90%;\n    font-size: large;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 100;\n    padding-left: 20px;\n}\n\n.add-products-form button{\n    width:120px;\n    height:50px;\n    background-color: #ed2727;\n    color:#fff;\n    border-radius: 5px;\n    cursor:pointer;\n}\n\n.add-products-form button:hover{\n    background-color:#ffa406 ;\n}\n\n.checkbox-container input{\n    width:20px;\n    height:20px;\n   \n}\n\n.add-products-form label {\n    height: 50px;\n   \n    width: 90%;\n    font-size: large;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 100;\n   \n    text-align: left;\n}\n\n.input-group{\n    display: flex;\n    padding:0px 50px;\n    width:90%;\n    \n    \n}\n\n.input-group select{\n    margin: 10px 0px;\n}\n\n@media screen and (max-width:768px){\n    .add-products{\n        width:100%;\n    }\n  .add-products-card {\n      width: 100%;\n      height: 100vh;\n      overflow: scroll;\n      background-color: #fff;\n      display: flex;\n      flex-direction: column;\n      justify-content: left;\n      align-items: left;\n      border-radius: 10px;\n      padding: 10px;\n      margin:20px auto;\n\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
